// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BOpx7","hint":"styles_hint__Ji9Qx","cards":"styles_cards__FknT0","action":"styles_action__BcUWi"};